import loadable from '@loadable/component';

export const Carousel = loadable(
  () =>
    import(
      /* webpackChunkName: "rt-carousel" */ '@redturtle/qubicaamf-theme/components/Blocks/Listing/Carousel/Carousel'
    ),
  { ssr: false }, //because it has styles for carousel to import
);

export const CarouselTemplate = loadable(
  () =>
    import(
      /* webpackChunkName: "rt-carousel" */ '@redturtle/qubicaamf-theme/components/Blocks/Listing/Carousel/CarouselTemplate.jsx'
    ),
);

export const DefaultSlideAppearance = loadable(
  () =>
    import(
      /* webpackChunkName: "rt-carousel-appearance" */ '@redturtle/qubicaamf-theme/components/Blocks/Listing/Carousel/SlideAppearance/DefaultSlideAppearance'
    ),
);

// export const CarouselReadMoreButton = loadable(
//   () =>
//     import(
//       /* webpackChunkName: "rt-carousel" */ '@redturtle/qubicaamf-theme/components/Blocks/Listing/Carousel/Slots/CarouselReadMoreButton'
//     ),
// );
